import { render, staticRenderFns } from "./other_access_tree.vue?vue&type=template&id=6308ed65&scoped=true"
import script from "./other_access_tree.vue?vue&type=script&lang=js"
export * from "./other_access_tree.vue?vue&type=script&lang=js"
import style0 from "./other_access_tree.vue?vue&type=style&index=0&id=6308ed65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308ed65",
  null
  
)

export default component.exports